// Modules
import React from 'react';

// Components
import TableTabs from '../../components/TableTabs/TableTabs';

// Blocks
import BasstrakkTable from '../BasstrakkTable/BasstrakkTable';
import BigBassTable from '../BigBassTable/BigBassTable';
import CatchesTable from '../CatchesTable/CatchesTable';

// Types
import { AdvertisementVariant, IBassTabsProps } from '../../types';

// Hooks
import {
  useAnglerCatches,
  useAoyStandings,
  useBasstrakkTableData,
  useCatchesTableData,
  useTournamentAnglers,
} from '../../hooks';

import Advertisement from '../../components/Advertisement/Advertisement';
import useWindowDimensions from '../../hooks/useWindowDimensions';
// import useWindowDimensions from '../../hooks/useWindowDimensions';
import AoyTable from '../AoyTable/AoyTable';

/**
 * Primary component that is rendered in Drupal
 */
const BassTabs = ({ cutlines, sponsors, tid, tournamentSeries }: IBassTabsProps) => {
  // Api data
  const anglers = useTournamentAnglers(tid, sponsors);
  const coanglers = useTournamentAnglers(tid, sponsors, true);
  const catches = useAnglerCatches(tid, window.bassConfig.bass_leaderboard.daydate);
  const showCoanglers = window.bassConfig.bass_leaderboard.show_coanglers;
  const aoy = useAoyStandings(tid);
  const BERKLEY_BIG_BASS_TID = 1356;

  // Basstrakk @todo add 'aoy' back when we decide to use it
  const basstrakkData = useBasstrakkTableData(anglers, catches, aoy);
  const coAnglerData = useBasstrakkTableData(coanglers, catches, aoy);
  // Catches: Sorting is handled in ReactTable using `initialState`
  const catchesData = useCatchesTableData(anglers, catches);
  // Big Bass: Sorting is handled in ReactTable using `initialState`
  // - Add the _BigBassRank based on the sort order
  const bigBassData = useCatchesTableData(anglers, catches);
  // AOY
  const aoyData = useBasstrakkTableData(anglers, catches, aoy);

  // We need a class for the stick top banner to move to the bottom of the
  // window on mobile
  const { width } = useWindowDimensions();
  const stickyClass = width < 1024 ? 'sticky' : '';

  return (
    <>
      <div className={`react-tabs__banner_ad ${stickyClass}`}>
        <div style={{ width: '100%' }} className="advertisement">
          <Advertisement variant={AdvertisementVariant.TOP} count={1} />
        </div>
      </div>
      <TableTabs>
        <BasstrakkTable
          cutlines={cutlines}
          data={basstrakkData}
          tabLabel="Standings"
          tabClass="drupal-tab-basstrakk"
          tid={tid}
          tournamentSeries={tournamentSeries}
        />
        {
          ['opens', 'nation', 'college'].includes(tournamentSeries) && showCoanglers ? (
            <BasstrakkTable
              cutlines={cutlines}
              data={coAnglerData}
              tabLabel="Co-Anglers"
              tabClass="drupal-tab-coanglers"
              tid={tid}
              tournamentSeries={tournamentSeries}
            />
          ) : <></>
        }
        {
          ['elite', 'classic'].includes(tournamentSeries) ? (
            <BigBassTable
              data={bigBassData}
              tabLabel= { tid === BERKLEY_BIG_BASS_TID ? "Berkley Big Bass" : "Phoenix Big Bass" }
              tabClass="drupal-tab-bigbass"
            />
          ) : <></>
        }
        <CatchesTable
          data={catchesData}
          tabLabel="Catch Times"
          tabClass="drupal-tab-catches"
        />
        {
          ['elite', 'classic'].includes(tournamentSeries) ? (
            <AoyTable data={aoyData} tabLabel="AOY" tabClass="drupal-tab-aoy" />
          ) : <></>
        }
      </TableTabs>
    </>
  );
};

export default BassTabs;
